import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { HttpUrlGenerator, DefaultDataServiceConfig } from '@ngrx/data';
import { Store } from '@ngrx/store';
import { LoggingService } from '../../../shared/services/logging/logging.service';
import { EfaactDataService } from '../../efaact.data-service';
import { ReconciliationFieldModel } from './reconciliation-field.model';
import * as data from './MOCK_DATA.json';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';

export const entityName = 'eFTemplate';
@Injectable()
export class ReconciliationFieldDataService extends EfaactDataService<ReconciliationFieldModel> {
    constructor (
        http: HttpClient,
        httpUrlGenerator: HttpUrlGenerator,
        log: LoggingService,
        config: DefaultDataServiceConfig,
        store: Store
    ) {
        super(http, httpUrlGenerator, entityName, log, config, store);
        this.log.verbose({
            type: `${this.entityName}DataService(ReconciliationFieldDataService)::`
        });
    }
    protected mapGetResponse(resp: any): any[] {
        this.log.verbose({
            type: `${this.entityName}DataService(ReconciliationFieldDataService):mapGetResponse:resp`,
            resp
        });
        return JSON.parse(resp) as any[];
    }
    mapItems(item: ReconciliationFieldModel): ReconciliationFieldModel {
        const result = {
            ...item,
            id: item.id || `${item.ProcessID}-${item.PropertyID}`
        };
        this.log.verbose({
            type: `${this.entityName}DataService(ReconciliationFieldDataService):mapItems`,
            item,
            result
        });
        return result;
    }
    getAll(): Observable<ReconciliationFieldModel[]> {
        throw new Error('ReconciliationFieldDataService requires parameters');
    }
}
